<template>
    <div class="d-flex flex-columns">
        <AutocompleteDisplay
            :collection="collection"
            item-text="title"
            item-value="id"
            :placeholder="placeholder"
            display-hide-details="auto"
            clearable
            v-bind="$attrs"
            @selected="selected"
            v-on="$listeners"
        />
        <IconBtn
            v-if="showEdit && value"
            margin-class="ma-0"
            color="transparent"
            icon-cls="pencil"
            icon-color="black"
            :tooltip="$t('edit_organizer_group')"
            :loading="loading"
            @click="editRecord"
        />
        <IconBtn
            v-if="showNew"
            margin-class="ma-0"
            color="transparent"
            icon-cls="new"
            icon-color="black"
            :tooltip="$t('create_organizer_group')"
            @click="newRecord"
        />
        <EditDialog
            v-if="showDlg"
            v-model="showDlg"
            :record="recordToEdit"
            @record-changed="recordChanged"
            @record-added="recordChanged"
        />
    </div>
</template>

<script>
import EditDialog from '@/components/organizer_group/EditDialog.vue';
import { OrganizerGroupCollection } from '@/models/OrganizerGroup';
import { mapActions } from 'vuex';

export default {
    name: 'OrganizerGroupSelectField',
    components: {
        EditDialog,
    },

    props: {
        collection: {
            type: OrganizerGroupCollection,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
        value: {
            type: Number,
            default: null,
        },
        showNew: {
            type: Boolean,
            default: true,
        },
        showEdit: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            recordToEdit: null,
            recordSelected: null,
            showDlg: false,
            loading: false,
        };
    },

    watch: {
        value: {
            handler(newValue) {
                this.valueChanged(newValue);
            },
            immediate: true,
        },
    },

    methods: {
        ...mapActions(['runAsync']),

        valueChanged(id) {
            if (id !== this.recordSelected?.getId()) {
                this.recordSelected = null;
            }
        },

        async loadRecordSelected(force = false) {
            if (!this.recordSelected || force) {
                this.recordSelected = await this.loadRecordForId(this.value);
            }
            return this.recordSelected;
        },

        async loadRecordForId(id) {
            if (!id) {
                return null;
            }
            const collection = new OrganizerGroupCollection();
            await this.runAsync(async () => await collection.query({ id }));
            return collection.first();
        },

        selected(record) {
            this.recordSelected = record;
        },

        newRecord() {
            this.recordToEdit = null;
            this.showDlg = true;
        },

        async editRecord() {
            this.loading = true;
            this.recordToEdit = await this.loadRecordSelected();
            this.loading = false;
            if (!this.recordToEdit) {
                this.$toast({
                    message: this.$t('record_not_found'),
                    color: 'error',
                });
                return;
            }
            this.showDlg = true;
        },

        async recordChanged(record) {
            this.recordSelected = record;
            this.$emit('selected', record);
        },
    },
};
</script>

<style lang="scss" scoped></style>
